export default "__VITE_ASSET__BlhkrFrE__"